import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetMountingSurfaceOptions = (
  context: ProductBuilderMachineContext,
) => string[];

export const getMountingSurfaceOptions: GetMountingSurfaceOptions = context => {
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { mounting_surface },
  } = baseProduct;
  return mounting_surface ? mounting_surface : [];
};
